module.exports = __webpack_public_path__ + "img/39a2d6b3089373e42e4578fd8753cbf4f8f04251.7fe0e125.png";